import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'for_each_additional_collective_bargaining_agreement_cba_not_cov'

export const dataPointDefinition = {
  retracedId: 'for_each_additional_collective_bargaining_agreement_cba_not_cov',
  name: 'For each additional Collective Bargaining Agreement (CBA) not covered above indicate:\r\r\n• the parties to the CBA\r\r\n• the % of the workforce covered by the CBA\r\r\n• the duration of the CBA (provide NUMBER value for duration in months)\r\r\n• an overview of the issues covered in the CBA',
  meta: {},
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wi-foa-52',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12460,
  sectionId: '2.2.8',
  impactArea: 'Freedom of Association and Collective Bargaining',
  impactAreaId: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
